import { h } from '@stencil/core';

const Icon = ({ width = '100%', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 79 29" fill="none" stroke="black" xmlns="http://www.w3.org/2000/svg">
      <path d="M78.5 2.68628V25.2301L66.7271 33.9972" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M56.4573 37.504L1.3501 19.2184V0.932861" stroke-linecap="round" stroke-linejoin="round" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.7124 22.4216C51.7898 26.5518 50.0315 30.5864 46.7852 31.4332C43.5389 32.28 40.0339 29.6183 38.9566 25.4882C37.8792 21.3581 39.6375 17.3235 42.8838 16.4767C46.1301 15.6299 49.6351 18.2915 50.7124 22.4216Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.2488 14.5171C11.7484 17.2633 11.0721 19.6863 9.73825 19.929C8.4044 20.1716 6.91809 18.1421 6.41847 15.3959C5.91885 12.6497 6.59513 10.2267 7.92898 9.98404C9.26283 9.74137 10.7491 11.7709 11.2488 14.5171Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M72.5165 10.3687C72.5165 10.3687 75.4904 12.1499 76.2614 14.9331C77.0324 17.7163 76.2614 20.9448 76.1513 21.3901C76.0411 21.8354 76.2614 23.1713 75.931 23.8393C75.6006 24.5073 70.8644 28.9604 65.357 29.851C59.8498 30.7416 53.0207 29.0717 53.0207 29.0717C53.0207 29.0717 55.8587 16.4893 44.7598 14.4878C38.1235 13.291 36.0583 21.5014 36.9394 24.2846C34.1858 23.6166 15.9016 18.1616 14.69 17.8276C13.4784 17.4936 12.7074 16.937 12.5973 15.8237C12.4871 14.7104 11.8263 9.25535 8.30161 8.47602C6.10695 7.99077 4.85736 10.7026 5.29795 13.9311C5.29795 13.9311 1.69286 11.3706 4.00595 3.9116C4.00595 3.9116 4.5567 2.90968 5.87845 2.57568"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Icon;
